export const CONTACT_PHONE_DISPLAY = "(306) 269-0254";
export const CONTACT_PHONE_E164 = "+13062690254";
export const CONTACT_PHONE_TEL_URL = `tel:${CONTACT_PHONE_E164}`;

const CONTACT_MESSAGE = "Hi, I'd like to talk about selling my Calgary home.";
const encodedMessage = encodeURIComponent(CONTACT_MESSAGE);

export const CONTACT_SMS_URL = `sms:${CONTACT_PHONE_E164}?body=${encodedMessage}`;
export const CONTACT_WHATSAPP_URL = `https://wa.me/13062690254?text=${encodedMessage}`;
